import {
  SET_SCROLL_TO,
} from './actionTypes';

export const setScrollTo = (scrollTo) => ({
  type: SET_SCROLL_TO,
  payload: scrollTo?.toString?.() || scrollTo,
});
